import { Navigate } from 'react-router-dom'
import { useAccess } from '@/shared/rbac'

/**
 * Role-aware redirect for the root route (/).
 * Sends users to their appropriate home page based on permissions.
 */
export function HomeRedirect() {
  const { homeRoute } = useAccess()
  return <Navigate to={homeRoute} replace />
}
